<template>
  <div class="homed" style='    border-radius: 20px;'>
    <!-- 新增内容容器 -->
    <div class="content-wrapper" ref="contentWrapper">
      <!-- <comhead :currendTab="currentTab" ref="comhead"></comhead> -->
      <div class="dt" :style="{ 'margin-top': comheadHeight + 'px' }"></div>
      <div class="con-box">
        <div>
          <div class="card-box-o">
            <div class="card-left">
              <img
                :src="
                  info.imgpath
                    ? info.imgpath
                    : 'data:image/png;base64,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'
                "
              />
            </div>
            <div
              style="
                margin-left: 30px;
                width: 879px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
              "
            >
              <div class="disju">
                <p class="left-p">{{ info.title }}</p>
             
              </div>

              <div class="flexright-tag">
                <span>{{ info.type }}</span>
                <span v-for="(t, i) in info.tags" :key="i" class="span">{{
                  t
                }}</span>
              </div>

              <p class="flexright-detail">{{ info.desc }}</p>

              <div class="listter">
                <div style="font-size: 14px; color: #999">
                  {{info.intro}}
                </div>
              </div>
            </div>
          </div>

          <div class="card-box-o-bg">
            <!-- <div class="box-box">
              <p class="bg-title"><span class="line"></span>剩余额度</p>
              <ul class="bg-ul">
                <li v-for="(item, index) in tslistsy" :key="index">
                  <p class="bg-ul-count">{{ item.count }}</p>
                  <p class="bg-ul-text">{{ item.title }}</p>
                </li>
              </ul>
            </div> -->
            <div class="box-box">
              <p class="bg-title"><span class="line"></span>模型说明</p>
              <div class="box-api">
                API<span
                  >（<span class="span">{{ info.api_count }}</span
                  > 次被调用）</span
                >
                <el-tooltip
                  popper-class="custom-tooltip-user"
                  class="item"
                  effect="dark"
                  content="用户可以通过 API 来调用此项目的所有功能"
                  placement="top"
                >
                  <i class="el-icon-question"> </i>
                </el-tooltip>
              </div>
              <div class="box-copy">
                <span>{{ info.url_api }}</span>
                <span class="i" @click="copyurl(info.url_api)">
                  <svg
                    t="1754893415343"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="6285"
                    width="22"
                    height="22"
                  >
                    <path
                      d="M951.1424 787.712c-21.76 0-39.3728-17.664-39.3728-39.424V78.7968H320.9984a39.3984 39.3984 0 0 1 0-78.7712h590.7712c43.4944 0 78.7712 35.2768 78.7712 78.7712V748.288c0 21.7344-17.6384 39.3728-39.3984 39.3728z m-196.9152-472.6272v630.144c0 43.52-35.2768 78.7712-78.7712 78.7712H124.0576a78.7712 78.7712 0 0 1-78.7456-78.7712V315.0848c0-43.52 35.2512-78.7712 78.7456-78.7712h551.3984c43.52 0 78.7712 35.2512 78.7712 78.7712zM124.0576 945.2288h551.3984V315.0848H124.0576v630.144z"
                      fill="#ffffff"
                      p-id="6286"
                    ></path>
                  </svg>
                </span>
              </div>
              <div class="box-api box-api-dis">
                <p>API参数</p>
                <el-radio-group
                  v-model="apitype"
                  size="small"
                  @change="apitypeChange"
                >
                  <el-radio-button label="精简版"></el-radio-button>
                  <el-radio-button label="完整版"></el-radio-button>
                </el-radio-group>
              </div>
              <div class="box-api box-small" v-if="apitype == '精简版'">
                <p><span class="dian"></span>输入参数</p>

                <el-table
                  :data="info.api_input"
                  border
                  style="width: 100%; margin-top: 20px"
                >
                  <el-table-column prop="name" label="参数名" width="180">
                  </el-table-column>
                  <el-table-column prop="type" label="类型" width="120">
                  </el-table-column>
                  <el-table-column prop="range" label="范围" width="100">
                  </el-table-column>
                  <el-table-column prop="default" label="默认值" width="80">
                  </el-table-column>
                  <el-table-column prop="desc" label="说明"> </el-table-column>
                </el-table>
                <p style="margin-top: 20px">
                  <span class="dian"></span>输出参数
                </p>
              
                <el-table
                  :data="info.api_output"
                  border
                  style="width: 100%; margin-top: 20px"
                >
                  <el-table-column prop="name" label="参数名" width="180">
                  </el-table-column>
                  <el-table-column prop="type" label="类型" width="120">
                  </el-table-column>

                  <el-table-column prop="desc" label="说明"> </el-table-column>
                </el-table>
              </div>
              <div class="box-api box-small" v-else>
                <p><span class="dian"></span>输入参数</p>

                <el-table
                  :data="info.all_api_input"
                  border
                  style="width: 100%; margin-top: 20px"
                >
                  <el-table-column prop="name" label="参数名" width="180">
                  </el-table-column>
                  <el-table-column prop="type"  label="类型" width="120">
                  </el-table-column>
                  <el-table-column prop="range" label="范围" width="100">
                  </el-table-column>
                  <el-table-column prop="default" label="默认值"  width="80">
                  </el-table-column>
                  <el-table-column prop="desc" label="说明"> </el-table-column>
                </el-table>
                <p style="margin-top: 20px">
                  <span class="dian"></span>输出参数
                </p>
                <el-table
                  :data="info.all_api_output"
                  border
                  style="width: 100%; margin-top: 20px"
                >
                  <el-table-column prop="name" label="参数名" width="180">
                  </el-table-column>
                  <el-table-column prop="type"  label="类型" width="120">
                  </el-table-column>

                  <el-table-column prop="desc" label="说明"> </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="box-box">
              <div class="disju">
                <p class="bg-title"><span class="line"></span>功能体验</p>
                <ul class="bg-type">
                  <li
                    :class="activeIndex == 0 ? 'active' : ''"
                    @click="liclick(0, '')"
                  >
                    <svg
                      t="1754891262734"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="6054"
                      width="16"
                      height="16"
                    >
                      <path
                        d="M945.2544 590.8992c-29.1328 0-54.272 15.8976-67.8912 39.424h-144.128l-114.0224-227.9936-87.808 321.8432L472.4736 75.264l-77.2352-6.656-149.7344 561.5104H0v78.7456h305.92l108.1344-405.6064 58.624 645.376 77.2608 6.7328 90.9824-333.7216 43.52 87.0912h192.9216a78.4384 78.4384 0 0 0 67.8912 39.424A78.8224 78.8224 0 0 0 1024 669.44a78.6176 78.6176 0 0 0-78.7456-78.5152z"
                        fill="#666666"
                        p-id="6055"
                      ></path></svg
                    >在线体验
                  </li>
                  <li
                    :class="activeIndex == 1 ? 'active' : ''"
                    @click="liclick(1, info.code_python)"
                  >
                    <svg
                      t="1754891245280"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="5823"
                      width="16"
                      height="16"
                    >
                      <path
                        d="M383.5392 10.0608c-103.3216 18.2784-122.0608 56.448-122.0608 127.0784v93.0304h244.3264v31.0784H169.8304c-71.0912 0-133.248 42.752-152.6784 123.904-22.4 93.0048-23.3216 151.04 0 248.192 17.3568 72.2432 58.7264 123.904 129.792 123.904h83.9168v-111.5392c0-80.6912 69.7088-151.7824 152.6784-151.7824h244.096c67.8912 0 122.0608-55.9872 122.0608-124.1088V136.9088c0-66.2784-55.7824-115.8656-122.0608-127.0784-81.8176-13.4912-170.752-12.8-244.096 0.2304z m-15.3088 64.9216c25.1392 0 45.9264 21.0176 45.9264 46.6176s-20.5568 46.3872-45.952 46.3872A46.1824 46.1824 0 0 1 322.304 121.6c0.2304-25.8304 20.5568-46.6176 45.9264-46.6176z m423.296 186.0352v108.5696c0 84.1216-71.3216 154.9824-152.6784 154.9824h-244.1216c-66.7392 0-122.0608 57.1392-122.0608 124.1088v232.6784c0 66.2784 57.6 105.1392 122.0608 124.1088 77.2608 22.6048 151.552 26.7264 244.1216 0 61.4656-17.8432 122.0352-53.7344 122.0352-124.1088v-93.0304h-243.8656v-31.104h366.1568c71.0912 0 97.3568-49.5872 122.0608-123.8784 25.6-76.544 24.448-150.144 0-248.2176-17.6128-70.6304-50.9696-123.8784-122.0608-123.8784h-91.648v-0.2304z m-137.3696 589.2352c25.344 0 45.9264 20.8128 45.9264 46.4128a46.2336 46.2336 0 0 1-45.9264 46.6176c-25.1392 0-45.952-21.0176-45.952-46.6176 0.256-25.856 20.8128-46.4128 45.952-46.4128z"
                        fill="#666666"
                        p-id="5824"
                      ></path></svg
                    >Python样例代码
                  </li>
                  <li
                    :class="activeIndex == 2 ? 'active' : ''"
                    @click="liclick(2, info.code_curl)"
                  >
                    <svg
                      t="1754891179559"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="5361"
                      width="16"
                      height="16"
                    >
                      <path
                        d="M369.80352 113.7664H284.42752a170.6752 170.6752 0 0 0-170.6496 170.6752v66.6368c0 15.104-6.016 29.568-16.6912 40.2688L16.67712 471.7568a56.8576 56.8576 0 0 0 0 80.4608l80.4352 80.4608a56.8832 56.8832 0 0 1 16.6912 40.2176v66.6624a170.6496 170.6496 0 0 0 170.6496 170.6496h85.3504a28.4416 28.4416 0 0 0 28.416-28.416v-56.9088a28.4416 28.4416 0 0 0-28.416-28.4416H284.42752a56.8832 56.8832 0 0 1-56.8832-56.8832v-66.6368a170.6752 170.6752 0 0 0-49.9968-120.704L137.35552 512l40.2176-40.2432a170.6752 170.6752 0 0 0 49.9968-120.6784V284.416a56.8832 56.8832 0 0 1 56.9088-56.8832h85.3248a28.4416 28.4416 0 0 0 28.416-28.4416V142.208a28.4416 28.4416 0 0 0-28.416-28.416zM1007.37152 471.7568l-80.4608-80.4096a57.0112 57.0112 0 0 1-16.6656-40.2688V284.416a170.6752 170.6752 0 0 0-170.6752-170.6752h-85.3248a28.4416 28.4416 0 0 0-28.4416 28.4416v56.9088a28.4416 28.4416 0 0 0 28.416 28.416h85.3504a56.8832 56.8832 0 0 1 56.9088 56.9088v66.6112a170.624 170.624 0 0 0 49.9968 120.7296l40.192 40.192-40.192 40.2432a170.752 170.752 0 0 0-49.9968 120.704v66.6368a56.8832 56.8832 0 0 1-56.9088 56.8832h-85.3248a28.4416 28.4416 0 0 0-28.4416 28.4416v56.8832a28.4416 28.4416 0 0 0 28.416 28.4416h85.3504a170.6496 170.6496 0 0 0 170.6752-170.6496v-66.6624a56.9088 56.9088 0 0 1 16.6656-40.2176l80.4608-80.4608a56.832 56.832 0 0 0 0-80.4608z"
                        fill="#666666"
                        p-id="5362"
                      ></path></svg
                    >CURL命令
                  </li>
                  <li
                    :class="activeIndex == 3 ? 'active' : ''"
                    @click="liclick(3, info.code_js)"
                  >
                    <svg
                      t="1754891228135"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="5592"
                      width="16"
                      height="16"
                    >
                      <path
                        d="M523.629935 0.009728c9.26688-0.179194 18.431364 2.099128 26.495086 6.604572l445.245439 247.466662a52.503789 52.503789 0 0 1 26.95587 45.79682v424.177366a52.529388 52.529388 0 0 1-24.600752 44.440067L603.883166 1015.961877a52.47819 52.47819 0 0 1-57.060431-0.819171l-98.428605-65.610537a52.529388 52.529388 0 0 1 58.26359-87.369786l70.16718 46.718389 340.493853-213.855022V330.801515l-391.564092-217.592493-356.723693 216.338137V689.905926l139.1312 61.489079a13.183545 13.183545 0 0 0 18.405765-11.980387V380.745392a52.503789 52.503789 0 0 1 105.007578 0v358.746024a118.191122 118.191122 0 0 1-165.933476 108.028273l-170.387721-75.3638A52.529388 52.529388 0 0 1 63.997792 724.055148v-424.177366a52.503789 52.503789 0 0 1 25.266328-44.900851L497.416439 7.587066c7.910127-4.787035 16.946615-7.423744 26.213496-7.577338z m125.79406 353.063019c33.61164 0 63.537008 3.660674 89.801702 11.00762 8.422109 2.483114 15.692259 7.884528 20.479293 15.231475 5.247819 7.346947 7.858929 15.564263 7.858929 24.677548v25.752712a19.634523 19.634523 0 0 1-8.908493 16.793021 20.018509 20.018509 0 0 1-18.892148 2.099127c-31.128526-10.162849-59.492348-15.205875-85.091464-15.205875-28.671011 0-43.057715 9.983656-43.057715 29.925367 0 17.509796 11.775594 29.694976 35.198786 36.734733h0.051198c48.945511 14.386704 83.094733 31.512513 102.396468 51.454225 19.148139 19.967311 28.901403 46.641591 28.901402 79.869244 0 77.053342-49.918278 115.503215-149.678036 115.503215-31.8965 0-60.797902-5.247819-86.65301-15.769056a39.243446 39.243446 0 0 1-19.506527-16.818619 52.529388 52.529388 0 0 1-6.809365-26.239095v-26.776676a15.743457 15.743457 0 0 1 8.39651-14.693893 17.944981 17.944981 0 0 1 17.330602-0.511983c27.672645 12.901955 55.012502 19.404131 81.917174 19.404131 31.486914 0 47.25597-10.495638 47.25597-31.486914 0-9.85566-2.406317-17.356201-7.346947-22.60402-4.863832-5.247819-13.797924-9.983656-26.802275-14.181911-46.590393-14.361105-80.125236-32.152491-100.809322-53.553352-20.351298-21.656853-30.462949-48.510326-30.462949-80.330029 0-34.328416 12.287576-61.258687 36.760331-80.893209 24.882342-19.608923 60.797902-29.387786 107.669886-29.387786z"
                        fill="#666666"
                        p-id="5593"
                      ></path></svg
                    >JS样例代码
                  </li>
                </ul>
              </div>
              <div
                v-if="activeIndex == 0"
                style="
                  display: grid;
                  grid-template-columns: repeat(2, 1fr);
                  gap: 10px;
                "
              >
                <div class="box-api box-small box-bor">
                  <p><span class="dian"></span>输入</p>
                  <div
                    v-if="
                      typetype == '图像理解' ||
                      (typetype == '图像生成' &&
                        info.title == 'Flux.1-Kontext-dev')
                    "
                    style="
                      display: flex;
                      margin-top: 15px;
                      font-size: 14px;
                      color: #666666;
                    "
                  >
                    <span class="imp">上传图像:&nbsp;</span>
                    <el-upload
                      v-loading="loadingimg"
                      style="flex: 1"
                      class="upload-demo"
                      :show-file-list="false"
                      accept=".jpg,.jpeg,.png,.gif,.bmp,.tif,.tiff,.webp,.svg,.ico,.raw"
                      drag
                      action="#"
                      multiple
                      :http-request="customUpload"
                      :before-upload="beforeUpload"
                      :auto-upload="true"
                    >
                      <svg
                        v-if="imgpath == ''"
                        style="margin-bottom: 10px"
                        t="1754890564140"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="5132"
                        width="65"
                        height="50"
                      >
                        <path
                          d="M512 144c158.0544 0 288.2816 119.0912 305.8688 272.4352a228.096 228.096 0 0 1-21.9392 455.0912H228.096a228.0704 228.0704 0 0 1-21.9392-455.0912C223.744 263.0912 353.9456 144 512 144z m0.768 220.0832h-0.2048a36.352 36.352 0 0 0-25.9584 10.6752l-146.7648 146.7648a36.48 36.48 0 1 0 51.6096 51.6096l84.0704-84.0704v219.776a36.48 36.48 0 1 0 72.96 0v-220.928l85.2224 85.2224 0.4096 0.4096a36.48 36.48 0 0 0 51.2-52.0192l-146.7648-146.7648-0.4352-0.4096a36.352 36.352 0 0 0-25.344-10.2656z"
                          fill="#4283F4"
                          p-id="5133"
                        ></path>
                      </svg>
                      <div class="el-upload__text" v-if="imgpath == ''">
                        将图片拖到此处，或<em>点击上传图片</em>
                      </div>
                      <div
                        v-if="imgpath != ''"
                        style="position: relative"
                        class="imgpath"
                      >
                        <img :src="imgpath" width="100%" />
                        <div class="imgmask"></div>
                        <div class="imgset">
                          <div>
                            <el-popover
                              style="margin-right: 30px"
                              placement="top-start"
                              title=""
                              width="800"
                              trigger="hover"
                            >
                              <img :src="imgpath" width="100%" />
                              <svg
                                slot="reference"
                                t="1754895144256"
                                class="icon"
                                viewBox="0 0 1024 1024"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                p-id="6516"
                                width="20"
                                height="20"
                              >
                                <path
                                  d="M511.9232 192C808.704 192 998.4 423.0144 1024 524.672c-26.1376 103.3472-215.296 332.8-512.0768 332.8S25.088 626.3296 0 524.672C25.728 424.064 215.0144 192 511.9232 192z m0 76.8256c-235.4176 0-393.472 170.8032-430.9248 256.2304 36.7872 85.248 193.9456 255.7184 430.9248 255.7184 236.2112 0 393.7792-170.7008 430.9504-255.9744-37.0432-85.4016-194.4832-255.9744-430.9504-255.9744z m0.0256 127.9232A128.0512 128.0512 0 0 1 640 524.8a128.0256 128.0256 0 0 1-128.0512 127.9232 127.9232 127.9232 0 0 1-127.9232-127.9232 127.9488 127.9488 0 0 1 127.9232-128.0512z m0 76.8256a51.2512 51.2512 0 0 0 0 102.4512c28.2112 0 51.2256-23.04 51.2256-51.2256 0-28.2112-22.8864-51.2-51.2256-51.2256z"
                                  fill="#ffffff"
                                  p-id="6517"
                                ></path>
                              </svg>
                            </el-popover>
                            <svg
                              @click.stop="viewdel"
                              t="1754895168072"
                              class="icon"
                              viewBox="0 0 1024 1024"
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                              p-id="6747"
                              width="20"
                              height="20"
                            >
                              <path
                                d="M341.3504 213.3248V128.0512A128.1024 128.1024 0 0 1 469.2736 0h85.504a127.7952 127.7952 0 0 1 127.8976 128.0512v85.2736h213.6832c23.3728 0 42.3168 18.944 42.3168 42.6752 0 23.552-19.4048 42.6752-42.3168 42.6752H127.6672A42.4448 42.4448 0 0 1 85.3504 256c0-23.552 19.4048-42.6752 42.3168-42.6752h213.6832z m85.3248 0h170.6752V128.0512a42.496 42.496 0 0 0-42.5728-42.7264h-85.504a42.752 42.752 0 0 0-42.5984 42.7264v85.2736z m384 215.7312a42.6752 42.6752 0 0 1 85.3504 0v467.2A127.7952 127.7952 0 0 1 768.256 1024H255.744A127.872 127.872 0 0 1 128 896.0512V431.6928a42.6496 42.6496 0 1 1 85.3248 0v464.3584c0 23.552 19.0208 42.624 42.4192 42.624h512.512a42.4704 42.4704 0 0 0 42.3936-42.4192V429.056z m-469.3248 104.3968c0-23.5008 19.328-42.7776 42.6752-42.7776 23.552 0 42.6496 19.456 42.6496 42.7776v255.744a42.9824 42.9824 0 0 1-42.6496 42.8032c-23.552 0-42.6752-19.456-42.6752-42.8032v-255.744z m256 0c0-23.5008 19.328-42.7776 42.6752-42.7776 23.552 0 42.6496 19.456 42.6496 42.7776v255.744a42.9824 42.9824 0 0 1-42.6496 42.8032c-23.552 0-42.6752-19.456-42.6752-42.8032v-255.744z"
                                fill="#ffffff"
                                p-id="6748"
                              ></path>
                            </svg>
                          </div>
                        </div>
                      </div>
                      <!-- <div class="el-upload__tip" slot="tip">
                        只能上传jpg/png文件，且不超过500kb
                      </div> -->
                    </el-upload>
                  </div>
                  <div
                    v-if="
                      typetype == '文本生成' ||
                      typetype == '图像理解' ||
                      typetype == '图像生成' ||
                      typetype == '视频生成'
                    "
                    style="
                      display: flex;
                      margin-top: 25px;
                      font-size: 14px;
                      color: #666666;
                      line-height: 40px;
                    "
                  >
                    <span class="imp">输入问题:&nbsp;</span>
                    <el-input
                      v-model="quinput"
                      :placeholder="placeholderq"
                      style="flex: 1"
                    >
                    </el-input>
                  </div>
                  <vodeotemp
                    v-if="typetype == '语音识别'"
                    @yyFun="yyFun"
                    :subloading="subloading"
                  ></vodeotemp>
                  <vodeoWrite
                    v-if="
                      typetype == '语音合成' &&
                      info.title == 'CosyVoice-300M-sft'
                    "
                    @yyhcFun="yyhcFun"
                    :subloading="subloading"
                  ></vodeoWrite>
                  <vodeoWriteI
                    v-if="
                      typetype == '语音合成' &&
                      info.title == 'CosyVoice-300M-Instruct'
                    "
                    @yyhcFun="yyhcFun"
                    :subloading="subloading"
                  ></vodeoWriteI>

                  <vodeoWriteb
                    v-if="
                      typetype == '语音合成' && info.title == 'CosyVoice2-0.5B'
                    "
                    @yyhcotherFun="yyhcotherFun"
                    :subloading="subloading"
                  ></vodeoWriteb>
                  <videoutemp
                    v-if="typetype == '视频理解'"
                    @submitFun="submitFun"
                    :subloading="subloading"
                  ></videoutemp>
                  <div
                    v-if="
                      typetype == '文本生成' ||
                      typetype == '图像理解' ||
                      typetype == '图像生成' ||
                      typetype == '视频生成'
                    "
                    style="
                      display: flex;
                      margin-top: 25px;
                      font-size: 14px;
                      color: #666666;
                      line-height: 40px;
                    "
                  >
                    <i style="visibility: hidden" class="imp">输入问题: </i>
                    <div class="submit" @click="subb" v-loading="subloading">
                      提交
                    </div>
                  </div>
                </div>
                <div class="box-api box-small">
                  <p style="margin-bottom: 10px !important">
                    <span class="dian"></span>  输出
                  </p>
                  <div class="sub" v-if="subvalue == '提交你的输入来获取输出'">
                    {{ subvalue }}
                  </div>
                  <div
                    v-if="
                      info.type == '图像生成' &&
                      subvalue !='提交你的输入来获取输出'
                    "
                  >
                    <img
                      :src="`data:image/png;base64,${subvalue}`"
                      width="100%"
                    />
                  </div>
                  <div
                    v-if="
                      (info.type == '文本生成' ||
                      info.type == '语音识别' ||
                        info.type == '图像理解' ||
                        info.type == '视频理解') &&
                      subvalue != '提交你的输入来获取输出'
                    "
                  >
                    <mavon-editor
                      class="sub"
                      v-model="subvalue"
                      :editable="false"
                      :subfield="false"
                      :defaultOpen="'preview'"
                      :toolbarsFlag="false"
                      :boxShadow="false"
                          :externalLink="external_link"
                    />
                  </div>
                  <div
                    v-if="
                      info.type == '视频生成' &&
                      subvalue != '提交你的输入来获取输出'
                    "
                  >
                    <video
                      :src="`${subvalue}`"
                      controls="controls"
                      width="100%"
                    ></video>
                  </div>
                  <div
                    v-if="
                      info.type == '语音合成' &&
                      subvalue != '提交你的输入来获取输出'
                    "
                  >
                    <audio
                      :src="`${subvalue}`"
                      controls="controls"
                      width="100%"
                    ></audio>
                  </div>
                </div>
              </div>
              <div class="subb" v-else>
                <p class="subb-copy" @click="copycode">复制</p>
                <pre>
                      <code class="python">
                      {{code}}
                      </code>
                      </pre>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <footerB class="footer_style"></footerB> -->
  </div>
</template>
<script>
// import footerB from "@/components/footer.vue";
// import comhead from "@/components/commHead.vue";
import vodeotemp from "@/components/vodeotemp.vue";
import vodeoWrite from "@/components/vodeoWrite.vue";
import vodeoWriteb from "@/components/vodeoWriteb.vue";
import videoutemp from "@/components/videoutemp.vue";
import vodeoWriteI from "@/components/vodeoWriteI.vue";

import gfm from "@bytemd/plugin-gfm";
import math from "@bytemd/plugin-math";
import pluginGemoji from "@bytemd/plugin-gemoji";
import "github-markdown-css"; // 引入基础样式
import { Editor, Viewer } from "@bytemd/vue";
const plugins = [gfm(), math(), pluginGemoji()];
const cityOptions = ["上海", "北京", "广州", "深圳"];
export default {
  name: "Dataset",
  components: {
    // footerB,
    // comhead,
    Viewer,
    vodeotemp,
    vodeoWrite,
    videoutemp,
    vodeoWriteb,
    vodeoWriteI,
  },
  data() {
    return {
         external_link: {
        markdown_css: function () {
          return "/cdn-lib/markdownCss/github-markdown.min.css";
        },
        hljs_js: function () {
          return "/cdn-lib/highlight/highlight.min.js";
        },
          hljs_css: function () {
          return "/cdn-lib/highlight/github.min.css";
        },
        // hljs_lang: function (lang) {
        //   return (
        //     "https://cdn.bootcdn.net/ajax/libs/highlight.js/11.3.1/languages/" +
        //     lang +
        //     ".min.js"
        //   );
        // },
        // hljs_css: function (css) {
        //   if (css) {
        //     return (
        //       "https://cdn.bootcdn.net/ajax/libs/highlight.js/11.3.1/styles/" +
        //       css +
        //       ".min.css"
        //     );
        //   }
        //   return "";
        // },
        katex_js: function () {
          return "/cdn-lib/KaTex/katex.min.js";
        },
        katex_css: function () {
          return "/cdn-lib/KaTex/katex.min.css";
        },
      },
      placeholderq: '请输入问题',
      loadingimg: false,
      typetype: "",
      subloading: false,
      subvalue: '提交你的输入来获取输出',
      code: "",
      imgpath: "",
      quinput: "",
      activeIndex: 0,
      loadingimg: false,

      // 精简输入
      tableData: [],
      // 精简输出
      tableDatacw: [],
      // 完整输入
      tableDatac: [],
      // 完整输出
      tableDataw: [],
      info: {
        // codeurl:
        //   "https://prodsvc.educg.net/ollama-qwen25-32b-q4-serve/v1/chat/completions",
        // _id: "6886eeae95ec0d1106258e03",
        // title: "Qwen2.5-32B-Instruct",
        // imgpath: require("../assets/DeepSeek1.png"),
        // intro: "<p>测试上传图片<b></b></p>",
        // priv: "1",
        // type: ["官方"],
        // stage: ["小学"],
        // apicount: 78,
        // tags: [
        //   { edit: false, title: "文本生成", checked: false, type: true },
        //   { edit: false, title: "v1.0", checked: false, type: false },
        //   { edit: false, title: "INT4", checked: false, type: false },
        //   { edit: false, title: "≥ 8K", checked: false, type: false },
        //   { edit: false, title: "10B~50B", checked: false, type: false },
        // ],
        // isreport: false,
        // chapter_count: 1,
        // classhours: 2,
        // mark_count: 9,
        // view_count: 136,
        // seqid: "227",
        // outline:
        //   '[{"id":1000,"label":"新章节1","type":"chapter","children":[{"id":1001,"label":"新课时1","type":"lesson","children":[],"_id":"6886eeae95ec0d1106258e06"}],"_id":"6886eeae95ec0d1106258e04"},{"id":1002,"label":"新课时2","type":"lesson","_id":"6886eeae95ec0d1106258e05"}]',
        // _sys_editor: "60191dab0d0f5248cc7c26d3",
        // city: "",
        // company: "",
        // provice: "",
        // from_course: {
        //   $oid: "687efea82e78041fed0b54f8",
        // },
        // copy_count: 7,
        // share_count: 20,
        // creator: "希冀教研中心",
        // time: "2025-08-06",
        // homework_count: 0,
        // desc: "Qwen2.5-32B-Instruct是阿里巴巴集团Qwen团队开发的325亿参数指令微调大型语言模型。该模型支持包括中英文在内的29种以上语言，具备强大的指令遵循能力，支持128K tokens的长上下文处理，可生成最多8K tokens内容。在编程、数学等领域表现优异，能够生成结构化数据如JSON格式输出。模型采用先进的Transformer架构，适用于客户服务、内容创作、教育研究等多种应用场景，提供高度可定制性。",
        // project_count: 1,
        // scheme_count: 2,
        // resource_count: 0,
        // collected: false,
      },
      apitype: '精简版',
      tslistsy: [],
      tempAry: [],
      checkAll: false,
      checkedCities: ["上海", "北京"],
      cities: cityOptions,
      isIndeterminate: true,
      cities: cityOptions,
      checkAll: false,
      isIndeterminate: true,
      checkedCities: [],
      classAry: [],
      classary: [],
      classAry: [],
      loading: false,
      plugins,
      activeNames: "",
      activeNamesks: "",
      activeName: "first",
      // info: {
      //   pic: require("../assets/chuangj.jpg"),
      // },
      currentTab: "model", // 确保它是响应式的
      comheadHeight: 0,
      qxg: "",
      dynamicTags: ["标签一", "标签二", "标签三"],
      inputVisible: false,
      inputValue: "",
      seqid: "",

      infotype: "",
      dialogVisible: false,
      dialogproject: false,
      txscImg: "",
      getkey:'',
      getmessage:''
    };
  },
  mounted() {
    this.getkeyFun()
    this.detailData();
    this.seqid = this.$route.query.id;

    this.$nextTick(() => {
      const comheadEl = this.$refs.comhead?.$el || null;
      console.log("comheadElcomheadEl", comheadEl);
      if (comheadEl) {
        this.comheadHeight = comheadEl.offsetHeight;
      }
    });
  },
  methods: {
        getkeyFun() {
      let data = {
        op: "getkey",
      };

      let _this = this;
      this.$axios
        .post("/index.do", _this.Qs.stringify(data), {
          headers: {
            Authorization:
              window.localStorage.getItem("anjing_name_token") || "",
          },
        })
        .then(function (response) {
          console.log(response);
          if (response.data.value == "ok") {
            // window.location.href = response.data.data;
            _this.getkey = response.data.data; //response.data.data;//有key
          } else if(response.data.value =='login_error'){
            // _this.$message.error(response.data.msg);
            _this.getkey = "";
            _this.getmessage= response.data.msg

          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    detailData() {
      let data = {
        op: "detail",
        _id: window.localStorage.getItem("anjign-wbzx-id"),
      };

      let _this = this;
      this.$axios
        // .post( /model.do", _this.Qs.stringify(data), {
        //   headers: {
        //     Authorization:
        //       window.localStorage.getItem("anjing_name_token") || "",
        //   },
        // })
        .get("/index.do", {
          params: {
            op: "detail",
            _id:  window.localStorage.getItem("anjign-wbzx-id"),
          },
        })
        .then(function (response) {
          console.log(response);
          if (response.data.value == "ok") {
            _this.info = response.data.data;
            _this.info.tags = _this.info.tags==""?[]:_this.info.tags//_this.info.tags==""?[]:JSON.parse(_this.info.tags)
            _this.info.api_input = _this.info.api_input?JSON.parse(_this.info.api_input):[];
            _this.info.api_output = _this.info.api_output?JSON.parse(_this.info.api_output):[];
            _this.info.all_api_input = JSON.parse(
              _this.info.all_api_input ? _this.info.all_api_input : "[]"
            );
            _this.info.all_api_output = JSON.parse(
              _this.info.all_api_output ? _this.info.all_api_output : "[]"
            );
            _this.typetype = _this.info.type//_this.info.model_type;
            _this.info.type = _this.info.type;
            _this.tslistsy = [
              { title: '文本生成模型', count: _this.info.wbsc },
              { title:  '图像理解模型', count: _this.info.txlj },
              { title: '图像生成模型', count: _this.info.txsc },
              { title: '语音识别模型', count: _this.info.yysb },
              { title: '语音合成模型', count: _this.info.yyhc },
              { title:'视频理解模型', count: _this.info.splj },
              { title: '视频生成模型', count: _this.info.spsc },
            ];
              if (
              _this.info.type == "文本生成" ){
              _this.placeholderq ='请输入文本问答问题'
            }
            else if (
              _this.info.type == "图像理解"
            ) {
              _this.placeholderq ='请输入文本问答问题'
            }
            else if (
              _this.info.type == "图像生成" &&
              _this.info.title == "Flux.1-Kontext-dev"
            ) {
              _this.placeholderq = '请输入文本问答问题'
            } else if (_this.info.type == "图像生成") {
              _this.placeholderq = '请输入图像描述'
            } else if (_this.info.type == "视频生成") {
              _this.placeholderq = '请输入视频描述';
            }
          } else if (response.data.value == "sessionerror") {
            _this.$message({
              message: response.data.msg,
              showClose: true, // 显示关闭按钮
              type: "error", // 可选类型：success/warning/info/error
            });
            _this.$router.push({ path: "/" });
            window.localStorage.setItem("loginName", "");
            window.sessionStorage.setItem("get_userinfo_qx", "");
          } else {
            _this.$message({
              message: response.data.msg,
              showClose: true, // 显示关闭按钮
              type: "error", // 可选类型：success/warning/info/error
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    customUpload(options) {
      this.loadingimg = true;
      const formData = new FormData();
      formData.append("op", "");
      formData.append("file", options.file);
      let _this = this;
   this.$axios
        .post( "/fileUpload.do", formData,  
        {headers: {
            Authorization:
              window.localStorage.getItem("anjing_name_token") || "",
          }})

        .then(function (response) {
          console.log(response);
          _this.loadingimg = false;
          if (response.data.value == "ok") {
            // _this.sczlData.push(response.data)
            // console.log(' _this.sczlData', _this.sczlData)
            // _this.fileList[_this.fileList.length - 1].fid = response.data.fid;
            // console.log("  _this.fileList  _this.fileList", _this.fileList);
            _this.imgpath = response.data.url;
            _this.txscImg = options.file;
          } else if (response.data.value == "sessionerror") {
            _this.$message({
              message: response.data.msg,
              showClose: true, // 显示关闭按钮
              type: "error", // 可选类型：success/warning/info/error
            });
            _this.$router.push({ path: "/" });
            window.localStorage.setItem("loginName", "");
            window.sessionStorage.setItem("get_userinfo_qx", "");
          } else {
            _this.$message({
              message: response.data.msg,
              showClose: true, // 显示关闭按钮
              type: "error", // 可选类型：success/warning/info/error
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      // if (this.fileList.length == 11) {
      //   this.$message.error("文件最多上传10个");
      //   return false;
      // }

      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 10MB!");
      }
      return isLt2M;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      // this.fileList = fileList;
    },
    // handleChangeUp() {
    //   this.imgpath = require("../assets/banneriphone.jpg");
    // },
    viewFun() {},
    viewdel() {
      this.imgpath = "";
    },
    async copyurl(url1) {
      //https://mo.zju.edu.cn/pyapi/apps/run/62b12fde34514bed5c29038b
      const url = url1; // 替换为目标 URL
      try {
        // 检查 navigator.clipboard 是否可用
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(url);
          this.$message({
            message:'复制成功',
            showClose: true, // 显示关闭按钮
            type: "success", // 可选类型：success/warning/info/error
          });
        } else {
          // 回退到 document.execCommand('copy')
          this.fallbackCopyTextToClipboard(url);
        }
      } catch (err) {
        console.error("复制失败:", err);

        this.$message({
          message: "复制失败，请重试",
          showClose: true, // 显示关闭按钮
          type: "error", // 可选类型：success/warning/info/error
        });
      }
    },
    async copycode() {
      //https://mo.zju.edu.cn/pyapi/apps/run/62b12fde34514bed5c29038b
      const url = this.code;
      try {
        // 检查 navigator.clipboard 是否可用
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(url);
          this.$message({
            message: '复制成功',
            showClose: true, // 显示关闭按钮
            type: "success", // 可选类型：success/warning/info/error
          });
        } else {
          // 回退到 document.execCommand('copy')
          this.fallbackCopyTextToClipboard(url);
        }
      } catch (err) {
        console.error("复制失败:", err);

        this.$message({
          message: "复制失败，请重试",
          showClose: true, // 显示关闭按钮
          type: "error", // 可选类型：success/warning/info/error
        });
      }
    },

    // 兼容性回退方案TH
    fallbackCopyTextToClipboard(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.width = "2em";
      textArea.style.height = "2em";
      textArea.style.opacity = "0";
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        this.$message.success('复制成功');
      } catch (err) {
        console.error("回退复制失败:", err);
        this.$message.error("复制失败，请重试");
      } finally {
        document.body.removeChild(textArea);
      }
    },
    apitypeChange(e) {
      // this.apitype = e;
    },
    liclick(index, tag) {
      this.activeIndex = Number(index);
      this.$set(this, "activeindex", index);
      console.log(this.activeIndex);
      this.code = tag;
    },
    // 判断节点是否为PPT资源（type为'p'表示PPT类型）
    isPptResource(data) {
      // 检查当前节点是否为PPT资源
      return data.type === "pptx";
    },
    ismp4ptResource(data) {
      // 检查当前节点是否为PPT资源
      return data.type === "mp4";
    },
    iswordptResource(data) {
      // 检查当前节点是否为PPT资源
      return data.type === "docx";
    },
    ismarkptResource(data) {
      // 检查当前节点是否为PPT资源
      return data.type === "markdown";
    },
    isproptResource(data) {
      // 检查当前节点是否为PPT资源
      return data.type === "project";
    },
    ishomptResource(data) {
      // 检查当前节点是否为PPT资源
      return data.type === "homework";
    },
    isimgptResource(data) {
      // 检查当前节点是否为PPT资源
      return data.type === "png" || data.type === "jpg" || data.type === "jpeg";
    },

    iszipptResource(data) {
      // 检查当前节点是否为PPT资源
      return data.type === "zip";
    },
    ispdfptResource(data) {
      // 检查当前节点是否为PPT资源
      return data.type === "pdf";
    },
    // handleCheckAllChange(val) {
    //   this.checkedCities = val ? this.classsAry : [];
    //   this.isIndeterminate = false;
    // },
    handleCheckAllChange(val) {
      console.log(val);
      this.tempAry = [];
      this.classAry.forEach((item) => {
        this.tempAry.push(item._id);
      });

      this.checkedCities = val ? this.tempAry : [];
      this.isIndeterminate = false;
      console.log(this.checkedCities);
    },
    handleCheckedCitiesChange(value) {
      console.log(value);
      console.log(this.checkedCities);
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.classAry.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.classAry.length;
    },
    clickClass() {
      //personal_space?id=3
      this.$router.push({ path: "/personal_space", query: { id: 3 } });
    },
    get_userinfo() {
      let data = {
        op: "get_userinfo",
      };

      let _this = this;
      return  this.$axios
        .post( "/userinfo.do", _this.Qs.stringify(data), {
          headers: {
            Authorization:
              window.localStorage.getItem("anjing_name_token") || "",
          },
        })
        .then(function (response) {
          console.log(response);
          if (response.data.value == "ok") {
            if (response.data.data.group != "teacher") {
              // 不是老师就提示
              window.sessionStorage.setItem("get_userinfo_qx", "false");
              return false;
            } else {
              window.sessionStorage.setItem("get_userinfo_qx", "true");
              return true;
            }
          } else if (response.data.value == "sessionerror") {
            //  _this.$message({
            //   message: response.data.msg,
            //   showClose: true, // 显示关闭按钮
            //   type: "error", // 可选类型：success/warning/info/error
            // });

            window.localStorage.setItem("loginName", "");

            window.sessionStorage.setItem("get_userinfo_qx", "");
            //  _this.$router.push({ path: "/" });
            return "sessionerror";
          } else {
            _this.$message({
              message: response.data.msg,
              showClose: true, // 显示关闭按钮
              type: "error", // 可选类型：success/warning/info/error
            });
            window.sessionStorage.setItem("get_userinfo_qx", "false");
            return false;
          }
        })
        .catch(function (error) {
          console.log(error);
          return false;
        });
    },
    copyFun() {
      this.get_userinfo().then((res) => {
        if (res && res != "sessionerror") {
          this.loading = true;
          let data = {
            op: "copy",
            _id: this.$route.query.id,
          };

          let _this = this;
     this.$axios
            .post( "/model.do", _this.Qs.stringify(data), {
              headers: {
                Authorization:
                  window.localStorage.getItem("anjing_name_token") || "",
              },
            })
            // this.$ajax
            //   .get( /course.do", {
            //     params: {
            //       // 传递的查询参数，可选
            //       op: "detail",
            //       _id: this.seqid,
            //     },
            //   })
            .then(function (response) {
              console.log(response);
              _this.loading = false;
              if (response.data.value == "ok") {
                _this.$message({
                  message: response.data.msg,
                  showClose: true, // 显示关闭按钮
                  type: "success", // 可选类型：success/warning/info/error
                });
              } else if (response.data.value == "sessionerror") {
                _this.$message({
                  message: response.data.msg,
                  showClose: true, // 显示关闭按钮
                  type: "error", // 可选类型：success/warning/info/error
                });
                _this.$router.push({ path: "/" });
                window.localStorage.setItem("loginName", "");
                window.sessionStorage.setItem("get_userinfo_qx", "");
              } else {
                _this.$message({
                  message: response.data.msg,
                  showClose: true, // 显示关闭按钮
                  type: "error", // 可选类型：success/warning/info/error
                });
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        } else if (res && res == "sessionerror") {
          this.$message({
            message: "请登录后操作！",
            showClose: true, // 显示关闭按钮
            type: "error", // 可选类型：success/warning/info/error
          });
          this.$router.push({ path: "/" });
        } else {
          this.$message({
            message: '暂无权限！',
            showClose: true, // 显示关闭按钮
            type: "error", // 可选类型：success/warning/info/error
          });
        }
      });
    },
    addFun() {
      this.get_userinfo().then((res) => {
        if (res && res != "sessionerror") {
          this.dialogproject = true;
          this.classlist();
        } else if (res && res == "sessionerror") {
          this.$message({
            message: "请登录后操作！",
            showClose: true, // 显示关闭按钮
            type: "error", // 可选类型：success/warning/info/error
          });
          this.$router.push({ path: "/" });
        } else {
          this.$message({
            message:'暂无权限!',
            showClose: true, // 显示关闭按钮
            type: "error", // 可选类型：success/warning/info/error
          });
        }
      });
    },
    classlist() {
      let data = {
        op: "choose_classlist",
        courseid: this.$route.query.id,
      };

      let _this = this;
    this.$axios
        .post( "/teacher/courses.do", _this.Qs.stringify(data), {
          headers: {
            Authorization:
              window.localStorage.getItem("anjing_name_token") || "",
          },
        })
        .then(function (response) {
          console.log(response);
          _this.loading = false;
          if (response.data.value == "ok") {
            _this.classAry = response.data.data;
            for (let i = 0; i < _this.classAry.length; i++) {
              if (_this.classAry[i].choose) {
                _this.checkedCities.push(_this.classAry[i]._id);
              }
            }
          } else if (response.data.value == "sessionerror") {
            _this.$message({
              message: response.data.msg,
              showClose: true, // 显示关闭按钮
              type: "error", // 可选类型：success/warning/info/error
            });
            _this.$router.push({ path: "/" });
            window.localStorage.setItem("loginName", "");
            window.sessionStorage.setItem("get_userinfo_qx", "");
          } else {
            _this.$message({
              message: response.data.msg,
              showClose: true, // 显示关闭按钮
              type: "error", // 可选类型：success/warning/info/error
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    sureFunproject() {
      if (this.checkedCities.length == 0) {
        this.$message({
          message: "请选择班级",
          showClose: true, // 显示关闭按钮
          type: "error", // 可选类型：success/warning/info/error
        });
        return;
      }
      let data = {
        op: "add_course_toclass",
        courseid: this.$route.query.id,
        classid: this.checkedCities,
      };

      let _this = this;
 this.$axios
        .post( "/teacher/courses.do", _this.Qs.stringify(data), {
          headers: {
            Authorization:
              window.localStorage.getItem("anjing_name_token") || "",
          },
        })
        .then(function (response) {
          console.log(response);
          _this.loading = false;
          if (response.data.value == "ok") {
            // _this.classAry = response.data.data;
            _this.$message({
              message: response.data.data
                ? response.data.data.msg
                : response.data.msg,
              showClose: true, // 显示关闭按钮
              type: "success", // 可选类型：success/warning/info/error
            });
            _this.dialogproject = false;
          } else {
            _this.$message({
              message: response.data.msg,
              showClose: true, // 显示关闭按钮
              type: "error", // 可选类型：success/warning/info/error
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    courseFun(obj) {
      console.log("obj", obj);
      window.localStorage.setItem("anjing_name_iframeurl", obj.iframeurl);

      window.localStorage.setItem("anjing_name_iframeurl_type", obj.type);
      // 资源id
      window.localStorage.setItem("anjing_name_iframeurl_id", obj._id);
      // 课时id
      window.localStorage.setItem("anjing_name_chapterid", obj.chapter_id);
      window.localStorage.setItem(
        "k12_project_name_opt",
        JSON.stringify(obj.label) || ""
      );
      window.localStorage.setItem(
        "k12_project_opt",
        JSON.stringify(obj.opt) || ""
      );

      this.$router.push({
        path: "/courseView",
        query: {
          id: obj._id,
          courseid: this.$route.query.id,
          back: this.$route.query.back ? this.$route.query.back : "",
          backid: this.$route.query.backid ? this.$route.query.backid : "",
        },
      });
    },
    download(content) {
      // window.open(content);
      window.location.href = content;
    },

    shareFun(id) {
      let _this = this;
      this.$axios
        .get( "/model.do", {
          params: {
            // 传递的查询参数，可选
            op: "share",
            _id: id,
          },
        })
        .then(function (response) {
          console.log(response);
          _this.dialogVisible = false;
          if (response.data.value == "ok") {
            _this.detailData();
            let urlnew = window.location.href.split("/#/")[0];
            console.log("urlnew", urlnew);
            let link = urlnew + "/#/opennessDetail?id=" + id;
            navigator.clipboard
              .writeText(link)
              .then(() => {
                // _this.$message.success("链接已复制到剪贴板");
                _this.$message({
                  message: "链接已复制到剪贴板",
                  showClose: true, // 显示关闭按钮
                  type: "success", // 可选类型：success/warning/info/error
                });
              })
              .catch((err) => {
                console.error("复制失败:", err);
                _this.$message({
                  message: "复制失败，请手动复制",
                  showClose: true, // 显示关闭按钮
                  type: "error", // 可选类型：success/warning/info/error
                });
              });
          } else if (response.data.value == "sessionerror") {
            _this.$message({
              message: response.data.msg,
              showClose: true, // 显示关闭按钮
              type: "error", // 可选类型：success/warning/info/error
            });
            _this.$router.push({ path: "/" });
            window.localStorage.setItem("loginName", "");
            window.sessionStorage.setItem("get_userinfo_qx", "");
          } else {
            _this.$message({
              message: response.data.msg,
              showClose: true, // 显示关闭按钮
              type: "error", // 可选类型：success/warning/info/error
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    handleClick() {
      if (this.activeName === "second") {
        this.$nextTick(() => {
          // 使用 scrollIntoView 滚动到课程目录
          this.$refs.courseDirectory.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        });
      } else {
        this.$nextTick(() => {
          // 使用 scrollIntoView 滚动到课程目录
          this.$refs.courseDirectoryf.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        });
      }
    },
    // 将图片 URL 转换为 Base64
    // async convertToBase64(imageUrl) {
    //   try {
    //     const response = await fetch(imageUrl);
    //     if (!response.ok) {
    //       throw new Error("图片加载失败");
    //     }
    //     const blob = await response.blob();
    //     return new Promise((resolve, reject) => {
    //       const reader = new FileReader();
    //       reader.onloadend = () => resolve(reader.result);
    //       reader.onerror = reject;
    //       reader.readAsDataURL(blob);
    //     });
    //   } catch (error) {
    //     console.error("转换失败:", error);
    //     this.$message.error("图片转换失败，请检查网络或链接是否有效");
    //   }
    // },
    async convertToBase64(imageUrl) {
  try {
    const response = await fetch(imageUrl);
    if (!response.ok) {
      throw new Error("图片加载失败");
    }
    const blob = await response.blob();

    // 🔥 强制转为 PNG 格式
    const pngBlob = new Blob([blob], { type: "image/png" });

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(pngBlob);
    });
  } catch (error) {
    console.error("转换失败:", error);
    this.$message.error("图片转换失败，请检查网络或链接是否有效");
  }
},
    async subb() {
      if (this.subloading) {
        return;
      }
         if(this.getmessage!=''){
        this.$message({
          message: this.getmessage,
          showClose: true, // 显示关闭按钮
          type: "error", // 可选类型：success/warning/info/error
        });
        return;
      }

      if (window.localStorage.getItem("apipass_anjing") == "暂无密钥") {
        this.$message({
          message: "请先申请密钥",
          showClose: true, // 显示关闭按钮
          type: "error", // 可选类型：success/warning/info/error
        });
        return;
      }
      // _this.tslistsy = [
      //       { title: "文本生成", count: _this.info.wbsc },
      //       { title: "图像理解", count: _this.info.txlj },
      //       { title: "图像生成", count: _this.info.txsc },
      //       { title: "语音识别", count: _this.info.yysb },
      //       { title: "语音合成", count: _this.info.yyhc },
      //       { title: "视频理解", count: _this.info.splj },
      //       { title: "视频生成", count: _this.info.spsc },
      //     ];

      if (this.info.type == "图像理解") {
        if (this.info.txlj == 0) {
          this.$message({
            message: "【图像理解】模型使用次数已用完，无法调用本类模型!",
            showClose: true, // 显示关闭按钮
            type: "error", // 可选类型：success/warning/info/error
          });
          return;
        }
        if (this.imgpath == "") {
          this.$message({
            message: "请上传图像",
            showClose: true, // 显示关闭按钮
            type: "error", // 可选类型：success/warning/info/error
          });
          return;
        }
        if (this.quinput == "") {
          this.$message({
            message: "请输入问题",
            showClose: true, // 显示关闭按钮
            type: "error", // 可选类型：success/warning/info/error
          });
          return;
        }
        window.localStorage.setItem("p_anjing_password", "sub");
        this.subloading = true;
        let data = {
          messages: [
            {
              role: "user",
              content: [
                { type: "text", text: this.quinput },
                {
                  type: "image_url",
                  image_url: {
                    url: await this.convertToBase64(this.imgpath),
                  },
                },
              ],
            },
          ],
          model: this.info.title,
                    demo:1,
        };

        let _this = this;
    this.$axios
          // .post( /model/chat_t.do", data, {
          .post("/v1/chat/model", data, {
            headers: {
              "Content-Type": "application/json",

              Authorization: this.getkey,
            },
          })
          .then(function (response) {
            window.localStorage.setItem("p_anjing_password", "");
            _this.subloading = false;
            console.log("response", response);
            // if (response.data.value == "ok") {
            const completion = response.data;
            console.log(response.data);

            _this.subvalue = completion.choices[0].message.content;
            _this.detailData();
            // } else {
            //   _this.$message({
            //     message: response.data.msg,
            //     showClose: true, // 显示关闭按钮
            //     type: "error", // 可选类型：success/warning/info/error
            //   });
            // }
          })
          .catch(function (error) {
            console.log(error);
            window.localStorage.setItem("p_anjing_password", "");
            _this.$message({
              message: "数据异常",
              showClose: true, // 显示关闭按钮
              type: "error", // 可选类型：success/warning/info/error
            });
          });
        // const response = await fetch(
        //   "https://prodsvc.educg.net/serve-qwen25-vl-7b-instruct/v1/chat/completions",
        //   {
        //     method: "POST",
        //     headers: {
        //       "Content-Type": "application/json",
        //       Authorization: "Bearer EMPTY",
        //     },
        //     body: JSON.stringify({
        //       messages: [
        //         {
        //           role: "user",
        //           content: [
        //             { type: "text", text: this.quinput },
        //             {
        //               type: "image_url",
        //               image_url: {
        //                 url: await this.convertToBase64(this.imgpath),
        //               },
        //             },
        //           ],
        //         },
        //       ],
        //       model: this.info.title,
        //     }),
        //   }
        // );

        // if (!response.ok) {
        //   throw new Error(`HTTP error! status: ${response.status}`);
        // }

        // const completion = await response.json();
        // console.log(completion.choices[0]);
        // this.subloading = false;
        // this.subvalue = completion.choices[0].message.content;
      } else if (this.info.type == "文本生成") {
        if (this.info.wbsc == 0) {
          this.$message({
            message: "【文本生成】模型使用次数已用完，无法调用本类模型!",
            showClose: true, // 显示关闭按钮
            type: "error", // 可选类型：success/warning/info/error
          });
          return;
        }
        if (this.quinput == "") {
          this.$message({
            message: "请输入提问",
            showClose: true, // 显示关闭按钮
            type: "error", // 可选类型：success/warning/info/error
          });
          return;
        }
        this.subloading = true;
        // const response = await fetch(
        //   // "https://prodsvc.educg.net/ollama-qwen25-32b-q4-serve/v1/chat/completions",
        //             this.url+"/model/chat_t.do",
        //   {
        //     method: "POST",
        //     headers: {
        //       "Content-Type": "application/json",
        //       // Authorization: "Bearer EMPTY",
        //             Authorization: window.localStorage.getItem("apipass_anjing"),
        //     },
        //     body: JSON.stringify({
        //       messages: [{ role: "user", content: this.quinput }],
        //       model: this.$route.query.type,
        //     }),
        //   }
        // );

        // if (!response.ok) {
        //   throw new Error(`HTTP error! status: ${response.status}`);
        // }

        // const completion = await response.json();
        // console.log(completion.choices[0]);
        // this.subloading = false;
        // this.subvalue = completion.choices[0].message.content;
        window.localStorage.setItem("p_anjing_password", "sub");
        let data = {
          messages: [{ role: "user", content: this.quinput }],
          model: this.info.title,
          stream: false,
          demo:1,

        };

        let _this = this;
this.$axios
          // .post( /model/chat_t.do", data, {
          .post("/v1/chat/model", data, {
            headers: {
              "Content-Type": "application/json",

                  Authorization: this.getkey,
            },
          })
          .then(function (response) {
            window.localStorage.setItem("p_anjing_password", "");
            _this.subloading = false;
            console.log("response", response);
            // if (response.data.value == "ok") {
            const completion = response.data;
            console.log(response.data);
            _this.subloading = false;
            _this.subvalue = completion.choices[0].message.content;
            _this.detailData();
            // } else {
            //   _this.$message({
            //     message: response.data.msg,
            //     showClose: true, // 显示关闭按钮
            //     type: "error", // 可选类型：success/warning/info/error
            //   });
            // }
          })
          .catch(function (error) {
            window.localStorage.setItem("p_anjing_password", "");
            console.log(error);
            _this.$message({
              message: "数据异常",
              showClose: true, // 显示关闭按钮
              type: "error", // 可选类型：success/warning/info/error
            });
          });
      } else if (
        this.info.type == "图像生成" &&
        this.info.title == "Flux.1-dev"
      ) {
        if (this.info.txsc == 0) {
          this.$message({
            message: "【图像生成】模型使用次数已用完，无法调用本类模型!",
            showClose: true, // 显示关闭按钮
            type: "error", // 可选类型：success/warning/info/error
          });
          return;
        }
        if (this.quinput == "") {
          this.$message({
            message: "请输入描述",
            showClose: true, // 显示关闭按钮
            type: "error", // 可选类型：success/warning/info/error
          });
          return;
        }
        this.subloading = true;
        window.localStorage.setItem("p_anjing_password", "sub");
        let data = {
          prompt: this.quinput,
          height: 1024,
          width: 1024,
          guidance_scale: 3.5,
          num_inference_steps: 20,
          max_sequence_length: 512,
          seed: 100,
          model: this.info.title,
        };

        let _this = this;
 this.$axios
          // .post( /model/img_rec.do", data, {
          .post( "/v1/img/model_rec", data, {
            headers: {
              "Content-Type": "application/json",

     Authorization: this.getkey,
            },
          })
          .then(function (response) {
            window.localStorage.setItem("p_anjing_password", "");
            _this.subloading = false;
            console.log("response", response);
            // if (response.data.value == "ok") {
            if (response.data.image_base64) {
              const imageBase64 = response.data.image_base64;
              console.log(imageBase64);
              _this.subloading = false;
              _this.subvalue = imageBase64;
              _this.detailData();
            } else {
              console.log("响应中未找到image_base64字段");
              console.log("响应内容:", response.data);
            }
            // const completion = response.data;
            // console.log(response.data);
            // _this.subloading = false;
            // _this.subvalue = completion.choices[0].message.content;

            // } else {
            //   _this.$message({
            //     message: response.data.msg,
            //     showClose: true, // 显示关闭按钮
            //     type: "error", // 可选类型：success/warning/info/error
            //   });
            // }
          })
          .catch(function (error) {
            window.localStorage.setItem("p_anjing_password", "");
            console.log(error);
            // _this.$message({
            //   message: "数据异常",
            //   showClose: true, // 显示关闭按钮
            //   type: "error", // 可选类型：success/warning/info/error
            // });
          });
        // const url = "https://prodsvc.educg.net/serve-flux-1-dev/generate";
        // const data1 = {
        //   prompt: this.quinput,
        //   height: 1024,
        //   width: 1024,
        //   guidance_scale: 3.5,
        //   num_inference_steps: 20,
        //   max_sequence_length: 512,
        //   seed: 100,
        // };

        // try {
        //   const response = await fetch(url, {
        //     method: "POST",
        //     headers: {
        //       "Content-Type": "application/json",
        //     },
        //     body: JSON.stringify(data1),
        //   });

        //   if (response.ok) {
        //     const result = await response.json();

        //     if (result.image_base64) {
        //       const imageBase64 = result.image_base64;
        //       console.log(imageBase64);
        //       this.subloading = false;
        //       this.subvalue = imageBase64;
        //     } else {
        //       console.log("响应中未找到image_base64字段");
        //       console.log("响应内容:", result);
        //     }
        //   } else {
        //     console.log(`请求失败，状态码: ${response.status}`);
        //     const errorText = await response.text();
        //     console.log("错误信息:", errorText);
        //   }
        // } catch (error) {
        //   console.error(`请求失败: ${error.message}`);
        // }
      } else if (
        this.info.type == "图像生成" &&
        this.info.title == "Flux.1-Kontext-dev"
      ) {
        if (this.info.txsc == 0) {
          this.$message({
            message: "【图像生成】模型使用次数已用完，无法调用本类模型!",
            showClose: true, // 显示关闭按钮
            type: "error", // 可选类型：success/warning/info/error
          });
          return;
        }
        if (this.quinput == "") {
          this.$message({
            message: "请输入描述",
            showClose: true, // 显示关闭按钮
            type: "error", // 可选类型：success/warning/info/error
          });
          return;
        }
        this.subloading = true;
        window.localStorage.setItem("p_anjing_password", "sub");
        // let data = {
        //   prompt: this.quinput,
        //   height: 1024,
        //   file: this.txscImg,
        //   width: 1024,
        //   guidance_scale: 3.5,
        //   num_inference_steps: 20,
        //   max_sequence_length: 512,
        //   seed: 100,
        //   model:this.info.title
        // };
        const formData = new FormData();

        formData.append("prompt", this.quinput);
        formData.append("height", 1024);
        formData.append("file", this.txscImg);
        formData.append("width", 1024);
        formData.append("guidance_scale", 3.5);
        formData.append("num_inference_steps", 20);
        formData.append("max_sequence_length", 512);
        formData.append("seed", 100);
        formData.append("model", this.info.title);

        let _this = this;
 this.$axios
          // .post( /model/img_rec_file.do", formData, {
          .post( "/v1/img/model_recfile", formData, {
            headers: {
              // "Content-Type": "application/json",

              Authorization: this.getkey,
            },
          })
          .then(function (response) {
            window.localStorage.setItem("p_anjing_password", "");
            _this.subloading = false;
            console.log("response", response);
            // if (response.data.value == "ok") {
            if (response.data.image_base64) {
              const imageBase64 = response.data.image_base64;
              console.log(imageBase64);
              _this.subloading = false;
              _this.subvalue = imageBase64;
              _this.detailData();
            } else {
              console.log("响应中未找到image_base64字段");
              console.log("响应内容:", response.data);
            }
            // const completion = response.data;
            // console.log(response.data);
            // _this.subloading = false;
            // _this.subvalue = completion.choices[0].message.content;

            // } else {
            //   _this.$message({
            //     message: response.data.msg,
            //     showClose: true, // 显示关闭按钮
            //     type: "error", // 可选类型：success/warning/info/error
            //   });
            // }
          })
          .catch(function (error) {
            console.log(error);
            window.localStorage.setItem("p_anjing_password", "");
            _this.$message({
              message: "数据异常",
              showClose: true, // 显示关闭按钮
              type: "error", // 可选类型：success/warning/info/error
            });
          });
        // const url = "https://prodsvc.educg.net/serve-flux-1-dev/generate";
        // const data1 = {
        //   prompt: this.quinput,
        //   height: 1024,
        //   width: 1024,
        //   guidance_scale: 3.5,
        //   num_inference_steps: 20,
        //   max_sequence_length: 512,
        //   seed: 100,
        // };

        // try {
        //   const response = await fetch(url, {
        //     method: "POST",
        //     headers: {
        //       "Content-Type": "application/json",
        //     },
        //     body: JSON.stringify(data1),
        //   });

        //   if (response.ok) {
        //     const result = await response.json();

        //     if (result.image_base64) {
        //       const imageBase64 = result.image_base64;
        //       console.log(imageBase64);
        //       this.subloading = false;
        //       this.subvalue = imageBase64;
        //     } else {
        //       console.log("响应中未找到image_base64字段");
        //       console.log("响应内容:", result);
        //     }
        //   } else {
        //     console.log(`请求失败，状态码: ${response.status}`);
        //     const errorText = await response.text();
        //     console.log("错误信息:", errorText);
        //   }
        // } catch (error) {
        //   console.error(`请求失败: ${error.message}`);
        // }
      } else if (this.info.type == "视频生成") {
        if (this.info.spsc == 0) {
          this.$message({
            message: "【视频生成】模型使用次数已用完，无法调用本类模型!",
            showClose: true, // 显示关闭按钮
            type: "error", // 可选类型：success/warning/info/error
          });
          return;
        }
        if (this.quinput == "") {
          this.$message({
            message: "请输入视频描述",
            showClose: true, // 显示关闭按钮
            type: "error", // 可选类型：success/warning/info/error
          });
          return;
        }
        this.subloading = true;
        const requestData = {
          prompt: this.quinput,
          // negative_prompt: document
          //   .getElementById("negativePrompt")
          //   .value.trim(),
          // height: parseInt(document.getElementById("height").value),
          // width: parseInt(document.getElementById("width").value),
          // num_frames: parseInt(document.getElementById("numFrames").value),
          // num_inference_steps: parseInt(
          //   document.getElementById("inferenceSteps").value
          // ),
          // guidance_scale: parseFloat(
          //   document.getElementById("guidanceScale").value
          // ),
          // max_sequence_length: parseInt(
          //   document.getElementById("maxSequence").value
          // ),
          // flow_shift: parseFloat(document.getElementById("flowShift").value),
          negative_prompt:
            "Bright tones, overexposed, static, blurred details, subtitles, style, works, paintings, images, static, overall gray, worst quality, low quality, JPEG compression residue, ugly, incomplete, extra fingers, poorly drawn hands, poorly drawn faces, deformed, disfigured, misshapen limbs, fused fingers, still picture, messy background, three legs, many people in the background, walking backwards",
          height: 480,
          width: 720,
          num_frames: 30,
          num_inference_steps: 20,
          guidance_scale: 5.0,
          max_sequence_length: 512,
          flow_shift: 3.0, //# 5.0 for 720P, 3.0 for 480P
        };

        const response = await fetch(
          "https://prodsvc.educg.net/serve-wan21-1-3b/generate",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const contentType = response.headers.get("content-type");
        console.log("响应类型:", contentType);

        if (
          contentType &&
          (contentType.includes("video") ||
            contentType.includes("application/octet-stream"))
        ) {
          // 获取视频数据
          var generatedVideoBlob = await response.blob(); // 创建视频URL
          // if (currentVideoUrl) {
          //   URL.revokeObjectURL(currentVideoUrl);
          // }
          let currentVideoUrl = URL.createObjectURL(generatedVideoBlob);
          console.log(currentVideoUrl);
          this.subloading = false;
          this.subvalue = currentVideoUrl;
        }
      }
    },
    async submitFun(obj) {
      if (this.subloading) {
        return;
      }
      this.subloading = true;
      const response = await fetch(
        "https://prodsvc.educg.net/serve-qwen25-vl-7b-instruct/v1/chat/completions",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer EMPTY",
          },
          body: JSON.stringify({
            messages: [
              {
                role: "user",
                content: [
                  {
                    type: "text",
                    text: obj.quinput,
                  },
                  {
                    type: "video_url",
                    video_url: {
                      url: obj.file,
                    },
                  },
                ],
              },
            ],
            model: this.info.title,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const completion = await response.json();
      console.log(completion.choices[0].message.content);
      this.subloading = false;
      this.subvalue = completion.choices[0].message.content;
    },

    async yhcFun(obj) {
      if (this.info.yyhc == 0) {
        this.$message({
          message: "【语音合成】模型使用次数已用完，无法调用本类模型!",
          showClose: true, // 显示关闭按钮
          type: "error", // 可选类型：success/warning/info/error
        });
        return;
      }
      if (this.subloading) {
        return;
      }
      this.subloading = true;
      const formData = new FormData();
      formData.append("file", obj.file);
      formData.append("model", "whisper-large:3");

      const response = await fetch(
        "https://prodsvc.educg.net/vllm-whisper-large-v3-serve/v1/audio/transcriptions",
        {
          method: "POST",
          headers: {
            Authorization: "Bearer EMPTY",
          },
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const completion = await response.json();
      return completion.text;
      this.subloading = false;
      this.subvalue = completion.choices[0].message.content;
    },

    createWavFile(
      pcmData,
      sampleRate = 22050,
      channels = 1,
      bitsPerSample = 16
    ) {
      const pcmBytes = pcmData.byteLength;
      const wavHeaderLength = 44;
      const wavBuffer = new ArrayBuffer(wavHeaderLength + pcmBytes);
      const view = new DataView(wavBuffer);

      // WAV文件头
      let offset = 0;

      // "RIFF" 标识
      view.setUint32(offset, 0x52494646, false); // RIFF
      offset += 4;

      // 文件大小（不包括前8字节）
      view.setUint32(offset, wavHeaderLength + pcmBytes - 8, true);
      offset += 4;

      // "WAVE" 标识
      view.setUint32(offset, 0x57415645, false); // WAVE
      offset += 4;

      // "fmt " 子块标识
      view.setUint32(offset, 0x666d7420, false); // fmt
      offset += 4;

      // fmt子块大小
      view.setUint32(offset, 16, true);
      offset += 4;

      // 音频格式（PCM = 1）
      view.setUint16(offset, 1, true);
      offset += 2;

      // 声道数
      view.setUint16(offset, channels, true);
      offset += 2;

      // 采样率
      view.setUint32(offset, sampleRate, true);
      offset += 4;

      // 字节率 (采样率 * 声道数 * 每样本字节数)
      const byteRate = sampleRate * channels * (bitsPerSample / 8);
      view.setUint32(offset, byteRate, true);
      offset += 4;

      // 块对齐 (声道数 * 每样本字节数)
      const blockAlign = channels * (bitsPerSample / 8);
      view.setUint16(offset, blockAlign, true);
      offset += 2;

      // 每样本位数
      view.setUint16(offset, bitsPerSample, true);
      offset += 2;

      // "data" 子块标识
      view.setUint32(offset, 0x64617461, false); // data
      offset += 4;

      // PCM数据大小
      view.setUint32(offset, pcmBytes, true);
      offset += 4;

      // 复制PCM数据
      const pcmView = new Uint8Array(pcmData);
      const wavView = new Uint8Array(wavBuffer);
      wavView.set(pcmView, offset);

      return wavBuffer;
    },
    async yyhcFun(obj) {
      if (this.info.yyhc == 0) {
        this.$message({
          message: "【语音合成】模型使用次数已用完，无法调用本类模型!",
          showClose: true, // 显示关闭按钮
          type: "error", // 可选类型：success/warning/info/error
        });
        return;
      }
      if (this.subloading) {
        return;
      }
      console.log(obj);
      this.subloading = true;

      // 代表要传自己的token
      window.localStorage.setItem("p_anjing_password", "sub");
      //this.$emit('yyhcFun',{'prompt_text':this.textareany,'tts_text':this.textareanz,type:'语音克隆',prompt_wav:this.upyy})

      const formData = new FormData();
      let currentUrl = "";
      if (obj.type == "内置语音") {
        formData.append("spk_id", obj.spk_id);
        formData.append("tts_text", obj.tts_text);
        formData.append("model", this.info.title);
        currentUrl =
          "https://prodsvc.educg.net/serve-cosyvoice-300m-sft/inference_sft";
      } else {
        formData.append("prompt_text", obj.prompt_text);
        formData.append("tts_text", obj.tts_text);
        formData.append("prompt_wav", obj.prompt_wav);
        formData.append("model", this.info.title);
        currentUrl =
          "https://prodsvc.educg.net/serve-cosyvoice-300m-instruct/inference_zero_shot";
      }

      let _this = this;
      this.$axios
        // .post( /model/audio_tts.do", formData, {
        .post( "/v1/audio/model_tts", formData, {
          headers: {
            // "Content-Type": "application/json",
           Authorization: this.getkey,
          },
          responseType: "arraybuffer",
        })
        .then(function (response) {
          window.localStorage.setItem("p_anjing_password", "");
          _this.subloading = false;
          console.log("responseresponseresponse111", response);
          // if (response.data.value == "ok") {
          const completion = response.data;
          console.log("completioncompletioncompletion", completion);
          // console.log(response.data);

          // 获取原始PCM数据
          // const pcmArrayBuffer =  completion.arrayBuffer();

          // 将PCM数据转换为正确的WAV格式
          const wavArrayBuffer = _this.createWavFile(completion, 22050, 1, 16);
          console.log("wavArrayBuffer", wavArrayBuffer);
          let synthesizedAudioBlob = new Blob([wavArrayBuffer], {
            type: "audio/wav",
          });
          //completion
          console.log(
            "synthesizedAudioBlob",
            URL.createObjectURL(synthesizedAudioBlob)
          );
          _this.subvalue = URL.createObjectURL(synthesizedAudioBlob);
          //  _this.detailData();
        })
        .catch(function (error) {
          window.localStorage.setItem("p_anjing_password", "");
          console.log("errorerrorerror", error);
          _this.$message({
            message: "数据异常",
            showClose: true, // 显示关闭按钮
            type: "error", // 可选类型：success/warning/info/error
          });
        });
      // const formData = new FormData();
      // formData.append(
      //   "tts_text",
      //   "语音合成是一种将文本信息转换为语音输出的人工智能技术"
      // );
      // formData.append("prompt_text", "希望你以后可以做得比我更好呦");
      // formData.append("prompt_wav", audioFile);
      // const response = await fetch(currentUrl, {
      //   method: "POST",
      //   headers: {
      //     Authorization: "Bearer EMPTY",
      //   },
      //   body: formData,
      // });

      // if (!response.ok) {
      //   this.subloading = false;
      //   window.localStorage.setItem("p_anjing_password", "");
      //   throw new Error(`HTTP error! status: ${response.status}`);
      // } // 获取原始PCM数据
      // window.localStorage.setItem("p_anjing_password", "");
      // console.log('responseresponseresponse',response)
      // const pcmArrayBuffer = await response.arrayBuffer(); // 将PCM数据转换为正确的WAV格式
      // const wavArrayBuffer = this.createWavFile(pcmArrayBuffer, 22050, 1, 16);
      // let synthesizedAudioBlob = new Blob([wavArrayBuffer], {
      //   type: "audio/wav",
      // });
      //    this.subloading = false;
      // this.detailData();
      // this.subvalue = synthesizedAudioBlob;
      // console.log("synthesizedAudioBlob", synthesizedAudioBlob);
    },
    async yyhcotherFun(obj) {
      if (this.info.yyhc == 0) {
        this.$message({
          message: "【语音合成】模型使用次数已用完，无法调用本类模型!",
          showClose: true, // 显示关闭按钮
          type: "error", // 可选类型：success/warning/info/error
        });
        return;
      }
      if (this.subloading) {
        return;
      }
      console.log(obj);
      this.subloading = true;
      // 代表要传自己的token
      window.localStorage.setItem("p_anjing_password", "sub");
      //this.$emit('yyhcFun',{'prompt_text':this.textareany,'tts_text':this.textareanz,type:'语音克隆',prompt_wav:this.upyy})

      const formData = new FormData();

      formData.append("instruct_text", obj.instruct_text);
      formData.append("tts_text", obj.tts_text);
      formData.append("prompt_wav", obj.prompt_wav);
      formData.append("model", this.info.title);

      let _this = this;
   this.$axios
        .post( "/v1/audio/model_tts", formData, {
          headers: {
            // "Content-Type": "application/json",

     Authorization: this.getkey,
          },
          responseType: "arraybuffer",
        })
        .then(function (response) {
          window.localStorage.setItem("p_anjing_password", "");
          _this.subloading = false;
          // if (response.data.value == "ok") {
          const completion = response.data;

          // 获取原始PCM数据
          // const pcmArrayBuffer =  completion.arrayBuffer();

          // 将PCM数据转换为正确的WAV格式
          const wavArrayBuffer = _this.createWavFile(completion, 22050, 1, 16);
          console.log("wavArrayBuffer", wavArrayBuffer);
          let synthesizedAudioBlob = new Blob([wavArrayBuffer], {
            type: "audio/wav",
          });
          //completion
          console.log(
            "synthesizedAudioBlob",
            URL.createObjectURL(synthesizedAudioBlob)
          );
          _this.subvalue = URL.createObjectURL(synthesizedAudioBlob);
          _this.detailData();
          // } else {
          //   _this.$message({
          //     message: response.data.msg,
          //     showClose: true, // 显示关闭按钮
          //     type: "error", // 可选类型：success/warning/info/error
          //   });
          // }
        })
        .catch(function (error) {
          window.localStorage.setItem("p_anjing_password", "");
          console.log(error);
          // _this.$message({
          //   message: "数据异常",
          //   showClose: true, // 显示关闭按钮
          //   type: "error", // 可选类型：success/warning/info/error
          // });
        });
      // const formData = new FormData();
      // formData.append("file", obj.file);
      // formData.append("model", "whisper-large:3");

      // const response = await fetch(
      //   "https://prodsvc.educg.net/vllm-whisper-large-v3-serve/v1/audio/transcriptions",
      //   {
      //     method: "POST",
      //     headers: {
      //       Authorization: "Bearer EMPTY",
      //     },
      //     body: formData,
      //   }
      // );

      // if (!response.ok) {
      //   throw new Error(`HTTP error! status: ${response.status}`);
      // }

      // const completion = await response.json();
      // return completion.text;
      // this.subloading = false;
      // this.subvalue = completion.choices[0].message.content;
      //    let data = {
      //     messages: [{ role: "user", content: this.quinput }],
      //     model: this.info.title,
      //     stream: false,
      //   };
    },
    //yyhcotherFun
    async yyFun(obj) {
      if (this.info.yysb == 0) {
        this.$message({
          message: "【语音识别】模型使用次数已用完，无法调用本类模型!",
          showClose: true, // 显示关闭按钮
          type: "error", // 可选类型：success/warning/info/error
        });
        return;
      }
      if (this.subloading) {
        return;
      }
      console.log(obj);
      this.subloading = true;
      // 代表要传自己的token
      window.localStorage.setItem("p_anjing_password", "sub");
      const formData = new FormData();
      formData.append("model", this.info.title);
      formData.append("file", obj.file);
      let _this = this;
 this.$axios
        // .post( /model/audio_rec.do", formData, {
        .post( "/v1/audio/model_rec", formData, {
          headers: {
            // "Content-Type": "application/json",

               Authorization: this.getkey,
          },
        })
        .then(function (response) {
          _this.subloading = false;
          console.log("response", response);
          // if (response.data.value == "ok") {
          const completion = response.data;
          console.log(response.data);
          _this.subloading = false;
          // 代表要传自己的token，记得要清除
          window.localStorage.setItem("p_anjing_password", "");
          // _this.subvalue = completion.choices[0].message.content;
          _this.subvalue = completion.text;
          _this.detailData();
          // } else {
          //   _this.$message({
          //     message: response.data.msg,
          //     showClose: true, // 显示关闭按钮
          //     type: "error", // 可选类型：success/warning/info/error
          //   });
          // }
        })
        .catch(function (error) {
          console.log(error);
          window.localStorage.setItem("p_anjing_password", "");
          _this.$message({
            message: "数据异常",
            showClose: true, // 显示关闭按钮
            type: "error", // 可选类型：success/warning/info/error
          });
        });
      // const formData = new FormData();
      // formData.append("file", obj.file);
      // formData.append("model", "whisper-large:3");

      // const response = await fetch(
      //   "https://prodsvc.educg.net/vllm-whisper-large-v3-serve/v1/audio/transcriptions",
      //   {
      //     method: "POST",
      //     headers: {
      //       Authorization: "Bearer EMPTY",
      //     },
      //     body: formData,
      //   }
      // );

      // if (!response.ok) {
      //   throw new Error(`HTTP error! status: ${response.status}`);
      // }

      // const completion = await response.json();
      // return completion.text;
      // this.subloading = false;
      // this.subvalue = completion.choices[0].message.content;
      //    let data = {
      //     messages: [{ role: "user", content: this.quinput }],
      //     model: this.info.title,
      //     stream: false,
      //   };
    },
    dz(id) {
      let data = {
        op: "mark",
        _id: this.seqid,
      };

      let _this = this;
      this.$axios
        .post( "/model.do", _this.Qs.stringify(data), {
          headers: {
            Authorization:
              window.localStorage.getItem("anjing_name_token") || "",
          },
        })
        .then(function (response) {
          console.log(response);
          if (response.data.value == "ok") {
            _this.detailData();
          } else if (response.data.value == "sessionerror") {
            _this.$message({
              message: response.data.msg,
              showClose: true, // 显示关闭按钮
              type: "error", // 可选类型：success/warning/info/error
            });
            _this.$router.push({ path: "/" });
            window.localStorage.setItem("loginName", "");
            window.sessionStorage.setItem("get_userinfo_qx", "");
          } else {
            _this.$message({
              message: response.data.msg,
              showClose: true, // 显示关闭按钮
              type: "error", // 可选类型：success/warning/info/error
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handleChange() {},
    handleChangeks() {},

    godetail(id) {
      let _this = this;
      this.$axios
        .get( "/model.do", {
          params: {
            // 传递的查询参数，可选
            op: "share",
            _id: id,
          },
        })
        .then(function (response) {
          console.log(response);
          // _this.dialogVisible = false;

          if (response.data.value == "ok") {
            _this.detailData();
            let urlnew = window.location.href.split("/#/")[0];
            console.log("urlnew", urlnew);
            let link = urlnew + "/#/modelDetail?id=" + id;
            // navigator.clipboard
            //   .writeText(link)
            //   .then(() => {
            //     // _this.$message.success("链接已复制到剪贴板");
            //     _this.$message({
            //       message: "链接已复制到剪贴板",
            //       showClose: true, // 显示关闭按钮
            //       type: "success", // 可选类型：success/warning/info/error
            //     });
            //   })
            //   .catch((err) => {
            //     console.error("复制失败:", err);
            //     _this.$message({
            //       message: "复制失败，请手动复制",
            //       showClose: true, // 显示关闭按钮
            //       type: "error", // 可选类型：success/warning/info/error
            //     });
            //   });

            try {
              // 检查 navigator.clipboard 是否可用
              if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(link);
                _this.$message({
                  message:'链接复制成功',
                  showClose: true, // 显示关闭按钮
                  type: "success", // 可选类型：success/warning/info/error
                });
              } else {
                // 回退到 document.execCommand('copy')
                _this.fallbackCopyTextToClipboard(link);
              }
            } catch (err) {
              console.error("复制失败:", err);

              _this.$message({
                message: "复制失败，请重试",
                showClose: true, // 显示关闭按钮
                type: "error", // 可选类型：success/warning/info/error
              });
            }
          } else if (response.data.value == "sessionerror") {
            _this.$message({
              message: response.data.msg,
              showClose: true, // 显示关闭按钮
              type: "error", // 可选类型：success/warning/info/error
            });
            _this.$router.push({ path: "/" });
            window.localStorage.setItem("loginName", "");
            window.sessionStorage.setItem("get_userinfo_qx", "");
          } else {
            _this.$message({
              message: response.data.msg,
              showClose: true, // 显示关闭按钮
              type: "error", // 可选类型：success/warning/info/error
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    fallbackCopyTextToClipboard(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.width = "2em";
      textArea.style.height = "2em";
      textArea.style.opacity = "0";
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        this.$message.success('链接复制成功');
      } catch (err) {
        console.error("回退复制失败:", err);
        this.$message.error("复制失败，请重试");
      } finally {
        document.body.removeChild(textArea);
      }
    },
    backFun() {
      window.localStorage.setItem(
        "currentpage_anjing_model",
        this.$route.query.page
      );
      this.$router.push({
        path: "/model",
      });
    },
  },
};
</script>
<style scoped>
.imgpath {
  width: 100%;
  height: 100%;
}

.imgpath:hover .imgset {
  display: flex;
}
.imgpath:hover .imgmask {
  display: block;
}
.imgmask {
  position: absolute;
  background: #000;
  opacity: 0.5;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: none;
}
.imgset {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  display: none;
}
code {
  color: #333333;
}
.imgset svg:nth-child(1) {
  margin-right: 20px;
}
/* 新增样式 */
.homed {
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* 关键属性 */
}
.content-wrapper {
  flex: 1; /* 关键属性-填充剩余空间 */
}
.goout {
  color: #333;
  text-align: center;
  font-size: 16px;
  margin-bottom: 30px;
}
.card-box-o {
  /* background: linear-gradient(180deg, #e0ecff 0%, #ffffff 30%, #ffffff 100%);
  border-radius: 20px; */
  padding: 20px 30px 20px;
  margin-bottom: 10px;
  display: flex;
  /* width:100% */
  background:#fff;
  border-radius: 20px;;
}
.card-box-o-bg {
  background: #fff;
  padding: 30px;
  border-radius: 20px;
}
.card-box-o-bg .bg-title {
  color: #333;
  font-size: 20px;
  font-weight: bold;
}
.card-box-o-bg .line {
  width: 4px;
  height: 20px;
  background: #2f77fa;
  margin-right: 5px;
  float: left;
  border-radius: 10px;
  margin-top: 3px;
}
.box-box {
  margin-bottom: 40px;
}
.box-copy {
  background: #f5f5f5;
  border-radius: 10px;
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #666666;
  padding-left: 20px;
  overflow: hidden;
  box-sizing: border-box;
  margin-top: 20px;
  margin-bottom: 30px;
  font-size: 16px;
}
.box-copy .i {
  width: 50px;
  height: 50px;
  display: flex;
  font-size: 30px;
  background: #4384f4;
  color: #fff;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.box-api-dis {
  display: flex;
  justify-content: space-between;
}

.box-api {
  font-size: 18px;
  color: #555555;
  font-weight: bold;
  margin-top: 20px;
}
.box-small {
  font-weight: 400;
  color: #333;
  font-size: 16px;
}
.box-small span {
  display: inline-block;
  width: 8px;
  height: 8px;
  background: #4283f4;
  border-radius: 10px;
  margin-right: 10px;
}

.box-api span {
  font-size: 14px;
  color: #999999;
  font-weight: 400;
}
.box-api .span {
  color: #555555;
}

.bg-ul {
  display: grid;
  grid-template-columns: repeat(8, 1fr); /* 三列等宽 */
  gap: 5px; /* 卡片间距 */
  margin-top: 20px;
}
.bg-ul li {
  width: 125px;
  height: 79px;
  background: #d6e5ff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #555555;
}
.bg-ul li .bg-ul-count {
  color: #333;
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 5px !important;
}

.con-box {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
  text-align: left;
  margin-bottom:20px;
}
.card-box-t {
  /* width: 600px;
  margin: 0 auto; */
}
.card-box-t p {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 15px !important;
}
.label-name {
  margin: 40px 0 7px;
  display: block;
  font-size: 20px;
}
.back {
  margin-bottom: 25px;
  margin-top: 30px;
  color: #fff;
  cursor: pointer;
  font-size: 16px;
}
.dt {
  /* background: #e9edf5 url(../../../assets/sjjbg.jpg) no-repeat; */
  position: fixed;
  background-size: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
  margin-top: 70px;
}
.submit {
  background: #4384f4;
  color: #fff;
  height: 40px;
  line-height: 40px;
  text-align: center;
  flex: 1;
  /* margin-left: 20px; */
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
}
/deep/.el-upload__text {
  font-size: 14px;
  color: #4283f4;
}
/deep/.el-upload-dragger {
  border: 1px dashed #d5ddeb;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}
/deep/.el-upload {
  width: 100%;
}
.el-upload-des {
  color: #999;
  font-size: 12px;
  margin-top: 16px;
}
.el-upload-pic {
  margin-bottom: 20px;
}
.open {
  border: 2px solid #d5ddeb;
  flex: 1;
  border-radius: 10px;
  height: 177px;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.btncreart {
  padding: 7px 10px;
  background: #4384f4;
  border-radius: 6px;
  text-align: center;
  color: #fff;
  margin-top: 20px;
}

.card-box-t .detail {
  color: #333;
  font-size: 16px;
  margin-top: 26px;
  line-height: 30px;
  font-weight: 400;
}
.flexright-tag {
  /* margin-top: 10px; */
  margin-bottom: 10px;
}
.flexright-tag span {
  background: #e6f0ff;
  color: #4384f4;
  margin-right: 10px;
  color: #3e79e0;
  font-size: 12px;
  border-radius: 4px;
  padding: 2px 8px;
}
.flexright-tag span.span {
  background: #f4f4f4;
  color: #666666;
}
.flexright-div {
  font-size: 14px;
  color: #555;
  font-weight: 400;
}
.flexright-icon {
  width: 36px;
  height: 36px;
  border-radius: 36px;
  overflow: hidden;
  margin-right: 6px;
  vertical-align: middle;
}
svg {
  vertical-align: sub;
}
.linew {
  width: 4px;
  height: 20px;
  background: #2f77fa;
  display: inline-block;
  border-radius: 20px;
  margin-right: 6px;
}
.linetitle {
  font-weight: bold;
  line-height: 20px;
}
.card-box-t .sjdetail {
  color: #666;
  font-size: 14px;
  line-height: 30px;
}
.filename {
  color: #333;
  font-size: 14px;
}

.filesize {
  color: #999;
  font-size: 12px;
}
.card-left {
  position: relative;
  width: 230px;
  height: 200px;
  border: 1px solid #dddddd;
  overflow: hidden;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-left img {
  width: 100px;
  height: 90px;
}
.rightkc {
  color: #fff;
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 4px;
  background: #ff7b42;
  position: absolute;
  right: 10px;
  top: 10px;
}
.flexright-tag {
  margin-top: 10px;
  margin-bottom: 20px;
}
.flexright-tag span {
  /* background: linear-gradient(180deg, #e2e9f5 0%, #ebf3ff 100%); */
  margin-right: 10px;
  color: #3e79e0;
  font-size: 12px;
  border-radius: 4px;
  padding: 4px 10px;
}
.left-p {
  font-size: 32px;
  color: #222;
  font-weight: bold;
}
.left-svg span {
  font-size: 16px;
}
.left-svg svg {
  width: 20px;
  height: 20px;
}
.listzj {
  margin-top: 20px;
  margin-bottom: 80px;
}
.listzj-title {
  font-size: 14px;
  color: #333;
  margin-right: 30px;
}
.listzj-num {
  font-size: 16px;
  color: #4384f4;
  font-weight: bold;
}
.listter {
  color: #999;
  display: flex;
}
.listter-title {
  color: #666;
}
.listter img {
  vertical-align: middle;
  margin-top: -4px;
  width: 27px;
  height: 27px;
  border-radius: 30px;
  margin-right: 9px;
}
.listter /deep/.el-divider--vertical {
  margin-bottom: 3px;
}
.listter-right {
  display: flex;
  flex-direction: column;
  margin-left: 25px;
}
.listter-right div {
  margin-bottom: 16px;
}
.hovershowBtn {
  float: right;
  background: linear-gradient(90deg, #2d78fa 0%, #ba5af2 100%);
  color: #fff;
  width: 102px;
  height: 32px;
  border-radius: 6px;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
  position: absolute;
  bottom: 40px;
  right: 0;
}
.btn-posi {
  right: 110px;
  background: #16a768;
}
.flexright-detail {
  color: #666;
  font-size: 14px;
  margin: 15px 0px 15px !important;
  /* background: #f5f7fa; */
  border-radius: 10px;

  font-weight: 400;
  box-sizing: border-box;
  /* height: 22px; */
  display: -webkit-box; /* 使用弹性盒子布局 */
  -webkit-box-orient: vertical; /* 设置主轴方向为垂直 */
  overflow: hidden; /* 隐藏超出容器的内容 */
  text-overflow: ellipsis; /* 使用省略号表示被隐藏的文本 */
  -webkit-line-clamp: 3;
}
/deep/ .el-tabs__item {
  font-size: 16px;
  color: #333333;
}
/deep/ .el-tabs__item.is-active {
  color: #222;
  font-weight: bold;
}
/deep/ .el-tabs__active-bar {
  background-color: #f86d3a;
  border-radius: 10px;
  height: 2px;
  width: 50px !important;
}
/deep/.el-tabs__nav-wrap {
  padding-left: 30px;
}
/deep/.el-tabs__active-bar {
  left: 7px;
}
/deep/ .el-tabs__content {
  padding: 0 30px;
}
/deep/ .el-tabs__header {
  margin-bottom: 0;
}
.kcjj {
  color: #555;
  font-size: 18px;
  font-weight: bold;
  margin-top: 30px;
}
.kcjj-p {
  font-size: 16px;
  color: #666;
  margin-top: 10px;
}
.box-bor {
  border-right: 1px solid #ddd;
  padding-right: 30px;
  margin-right: 30px;
  position: relative;
}
.sub {
  color: #999;
  font-size: 14px;
  /* padding: 20px; */
  /* max-height: 300px;
    overflow: auto; */
}
.subb {
  color: #999;
  font-size: 14px;
  padding: 20px;

  background: #f9f9f9;
  margin-top: 20px;
  position: relative;
}
.subb-copy {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 14px;
  color: #4384f4;
  cursor: pointer;
}
.en .bg-ul-text{
  font-size:12px;
}
/deep/.el-collapse-item__header {
  background-color: #f3f5f9;
  padding-left: 10px;
}
.collapseP /deep/.el-collapse-item__header {
  background-color: #ffffff;
  padding-left: 10px;
}
/deep/.el-collapse-item {
  margin-bottom: 10px;
}

/deep/.el-collapse-item__content {
  padding-bottom: 0;
  margin-top: 10px;
}
.collhove:hover {
  background: #ebf0fa;
}
/deep/.el-collapse-item__wrap {
  border: none;
}
.detial-dio /deep/.el-dialog {
  background: url("../../../assets/fxtc.jpg") no-repeat;
  border-radius: 8px;
  background-size: cover;
}
.detial-pnk /deep/.el-dialog {
  background: url("../../../assets/xmbjbg.jpg") no-repeat;
  border-radius: 8px;
  background-size:cover ;
}
/deep/.el-dialog__header {
  background: none;
  border: none;
}
ialog-title {
  color: #fff;
  font-size: 42px;
  text-align: center;
}
.detial-pnk /deep/.el-tabs__active-bar {
  height: 3px;
  border-radius: 10px;
  background-color: #f86d3a;
}
.detial-pnk /deep/.el-tabs__item.is-active {
  /* font-weight: bold; */
  color: #333;
}
.detial-pnkadd /deep/.el-tabs__nav {
  /* width: 475px;
    margin: 0 auto;*/
  /* flo.dat: none;
  display: table;
  margin: 0 auto; */
}
.detial-pnk /deep/.el-tabs__nav-wrap::after {
  background-color: transparent;
}
.dialog-copy {
  background: #ffffffa1;
  padding: 12px 20px;
  border-radius: 8px;
  text-align: center;
  color: #000;
  width: 152px;
  margin: 70px auto 0;
  font-size: 18px;
  cursor: pointer;
  font-weight: 400;
}
/deep/.el-collapse {
  border: none;
}
.dialog-des {
  color: #fff;
  line-height: 35px;
  font-size: 18px;
  padding: 0 20px;
  margin-top: 30px;
  margin-bottom: 70px;
}
/*****弹窗 */
.project-title {
  font-weight: bold;
  text-align: center;
  font-size: 24px;
  color: #222;
  margin-bottom: 24px !important;
}
.project-title-box .title {
  font-size: 16px;
  color: #333;
}
::v-deep .detial-pnk .el-dialog {
   background: url("../../../assets/xmbjbg.jpg") no-repeat;
  border-radius: 8px;
  background-size:cover ;
}
.detial-pnk /deep/.el-tabs__item {
  font-size: 16px;
  /* font-weight: bold; */
  color: #666;
}

/deep/.el-dialog__body {
 padding: 10px 30px !important;
}
.detial-pnk /deep/.el-tabs__active-bar {
  height: 3px;
  border-radius: 10px;
  background-color: #f86d3a;
}
.detial-pnk /deep/.el-tabs__item.is-active {
  /* font-weight: bold; */
  color: #333;
}
.detial-pnkadd /deep/.el-tabs__nav {
  /* width: 475px;
    margin: 0 auto;*/
  float: none;
  display: table;
  margin: 0 auto;
}
.disju {
  display: flex;
  justify-content: space-between;
}
.detial-pnk /deep/.el-tabs__nav-wrap::after {
  background-color: transparent;
}
/deep/.el-dialog__header {
  border: none;
  background: transparent;
}
.sureFunbtn {
  text-align: right;
  margin-top: 20px;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
.sureFunbtn span.o {
  display: inline-block;
  width: 62px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  margin-left: 10px;
  border-radius: 3px;
  cursor: pointer;
}
/*****弹窗 */
/deep/ .el-checkbox.is-bordered {
  background: #fff;
}
/deep/.el-checkbox.is-bordered {
  background: #fff;
}
/deep/.el-checkbox-group {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  width: 83%;
}
/deep/.el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 0;
}
.dialog-title {
  color: #fff;
  font-size: 42px;
  text-align: center;
}
/deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #4283f4;
  border-color: #4283f4;
}
/deep/ .el-table th.el-table__cell {
  background-color: #f1f5f9;
}
.bg-type {
}
.bg-type li {
  float: left;
  margin-left: 15px;
  background: #e8e8e8;
  padding: 6px 23px;
  border-radius: 21px;
  font-size: 14px;
  color: #666;
  cursor: pointer;
}
.bg-type li.active {
  background: #4283f4;
  color: #fff;
}
.bg-type li svg {
  margin-right: 5px;
}

.bg-type li.active svg path {
  fill: #ffffff;
}
.box-api .imp {
  width: 100px;
  display: inline-block;
  height: auto;
  background: transparent;
  margin-right: 0;
  color: #666;
}
.en .box-api .imp{
    width: 120px;
}
  
/deep/.el-table thead {
  color: #333;
}
/deep/.el-table--border .el-table__cell:first-child .cell {
  color: #333;
}
pre {
  width: 100%;
  overflow: auto;
}
/deep/.el-radio-button--small .el-radio-button__inner {
  font-size: 14px;
}
@media screen and (max-width: 1919px) {
  .dialog-title {
    font-size: 30px;
  }
  .left-p {
    font-size: 28px;
  }
  .card-left img {
    /* border-radius: 20px;
    width: 220px;
    height: 190px; */
  }
  .dialog-title {
    font-size: 40px;
  }
}
@media screen and (max-width: 1600px) {
  .submit {
    font-size: 14px;
  }
  .back {
    margin-bottom: 20px;
    margin-top: 25px;
  }
  .dialog-title {
    font-size: 30px;
  }
  .card-box-o {
    padding: 10px 20px 10px;
  }
  .left-p {
    font-size: 24px;
  }
  .card-left img {
    /* border-radius: 20px;
    width: 200px;
    height: 170px; */
  }
  .listzj-title {
    font-size: 12px;
  }
  .listzj {
    margin-bottom: 67px;
  }
  .hovershowBtn {
    width: 90px;
    height: 27px;
    line-height: 27px;
  }
  .card-box-o-bg {
    padding: 20px;
  }
  .card-box-o-bg .bg-title {
    font-size: 16px;
  }
  .bg-type li {
    font-size: 13px;
    padding: 4px 17px;
  }
  .box-copy {
    height: 44px;
    font-size: 14px;
  }
  /deep/.el-radio-button--small .el-radio-button__inner {
    font-size: 12px;
  }
  .box-api span {
    font-size: 12px;
  }
  .box-api {
    font-size: 14px;
  }
  .card-box-o-bg .line {
    height: 18px;
  }
  /deep/ .el-tabs__item {
    font-size: 14px;
  }
  .label-name {
    font-size: 18px;
  }
  .dialog-title {
    font-size: 25px;
  }
  .dialog-copy {
    font-size: 15px;
    padding: 8px 9px;
  }
  .dialog-copy svg {
    width: 17px;
    height: 17px;
  }
  .sureFunbtn span.o {
    width: 55px;
    height: 26px;
    text-align: center;
    line-height: 26px;
  }
  .left-svg span {
    font-size: 12px;
  }
  .left-svg svg {
    width: 16px;
    height: 16px;
  }
}
</style>
<style>
.custom-tooltip-user {
  /* pointer-events: auto; */
  padding: 10px !important;
}
</style>